import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AxiosController from "../../../../authentication/AxiosController";
import { useParams, useLocation } from "react-router-dom";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import Loader from "../../../../loader/Loader";
import { Button } from "react-bootstrap";
import StatisticsSearchComponent from "../search components/StatisticsSearchComponent";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export const ProductChart = () => {
  const { t } = useTranslation("global");
  const token = localStorage.getItem("token");
  const { slug, lang } = useParams();
  const location = useLocation();
  const box_head_dir = lang === "en" ? "ltr" : "rtl";

  const [search, setSearch] = useState(false);
  const [allStats, setAllStats] = useState({});
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [productId, setProductId] = useState("");

  const urlParams = new URLSearchParams(location.search);

  useEffect(() => {
    setProductId(urlParams.get("product_id") || "");
    setStartDate(urlParams.get("start_date") || "");
    setEndDate(urlParams.get("end_date") || "");
  }, [location.search]);

  useEffect(() => {
    if (productId && slug && lang) {
      get_product();
    }
  }, [productId, slug, lang, startDate, endDate]);

  const get_product = () => {
    setLoading(true);
    AxiosController.get(
      `api/${slug}/${lang}/reports/products/statstics/${productId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          start_date: startDate,
          end_date: endDate,
          product_id: productId,
        },
      }
    )
      .then((res) => {
        setAllStats(res.data);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        console.error("Failed to fetch product statistics:", e);
      });
  };

  const months = Object.keys(allStats);
  const delivered = months.map(
    (month) => allStats[month]?.delivered_count || 0
  );
  const cancelled = months.map(
    (month) => allStats[month]?.cancelled_count || 0
  );
  const shipped = months.map((month) => allStats[month]?.shipped_count || 0);
  const inProgress = months.map(
    (month) => allStats[month]?.in_progress_count || 0
  );
  const totalOrders = months.map((month) => allStats[month]?.total_orders || 0);

  const data = {
    labels: months,
    datasets: [
      {
        label: t("panel.total_orders"),
        data: totalOrders,
        backgroundColor: "#9C27B0",
      },
      {
        label: t("panel.delivered"),
        data: delivered,
        backgroundColor: "#4CAF50",
      },
      {
        label: t("panel.cancelled"),
        data: cancelled,
        backgroundColor: "#F44336",
      },
      {
        label: t("panel.shipped"),
        data: shipped,
        backgroundColor: "#2196F3",
      },
      {
        label: t("panel.in_progress"),
        data: inProgress,
        backgroundColor: "#FFC107",
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      tooltip: { mode: "index", intersect: false },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      x: { stacked: false },
      y: { stacked: false, beginAtZero: true },
    },
  };

  return (
    <div className="mt-3" style={{ direction: box_head_dir }}>
      <Button
        className="fs-5 w-25 mb-4 align-self-start"
        style={{
          backgroundColor: "rgb(89, 198, 201)",
          border: "none",
          borderRadius: "7px",
        }}
        onClick={() => setSearch(!search)}
      >
        {t("panel.search")}
      </Button>

      {search && <StatisticsSearchComponent type={"product"} />}

      <div className="reports-header d-flex flex-column flex-md-row py-2 justify-content-between flex-wrap">
        <h3 className="fs-2" style={{ color: "rgba(89, 198, 201, 1)" }}>
          {t("panel.statistics_title_chart")}
        </h3>
      </div>

      {loading ? (
        <Loader active={loading} />
      ) : (
        <Bar data={data} options={options} />
      )}
    </div>
  );
};
